import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { fDateTime } from '../../utils/formatTime';
import type { RequestProps } from '../../models';

const style = {
	divider: {
		borderBottomWidth: 1.5,
	},
};

interface AssessmentDatesProps {
	assessmentDate: RequestProps['assessmentDates'][number];
}

export const AssessmentDates: React.FC<AssessmentDatesProps> = ({ assessmentDate }) => (
	<>
		<CardHeader title="Assessment Date" />
		<Divider sx={style.divider} />
		<CardContent>
			<Grid container spacing={2}>
				<Grid size={{ xs: 6 }}>
					<Typography variant="body1" gutterBottom>
						{fDateTime(assessmentDate)}
					</Typography>
				</Grid>
			</Grid>
		</CardContent>
	</>
);
